import { jsx as _jsx } from "react/jsx-runtime";
import { Marker } from 'react-leaflet';
import { divIcon } from 'leaflet';
import { useUserStore } from '../../store/userStore';
const createUserIcon = () => {
    const svgIcon = `
    <svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
      <circle cx="16" cy="16" r="12" fill="#4285F4" stroke="#fff" stroke-width="2" opacity="0.9"/>
      <circle cx="16" cy="16" r="6" fill="#fff"/>
      <circle cx="16" cy="16" r="2" fill="#4285F4"/>
    </svg>
  `;
    return divIcon({
        html: svgIcon,
        className: 'user-location-icon',
        iconSize: [32, 32],
        iconAnchor: [16, 16],
    });
};
const userIcon = createUserIcon();
export default function UserMarker() {
    const { location } = useUserStore();
    if (!location) {
        return null;
    }
    return (_jsx(Marker, { position: location, icon: userIcon, title: "Your location" }));
}
